import React from 'react'
import propTypes from 'prop-types'
import { FaUpload } from 'react-icons/fa'
import { useDropzone } from 'react-dropzone'
import classNames from 'classnames'
import { useClient } from 'jsonapi-react'

import { uploadFiles } from 'helpers'
import Loader from 'components/Loader'


export default function DropUpload(props) {
  const [dragFiles, setDrag] = React.useState(false)
  const [uploading, setUploading] = React.useState(false)
  const client = useClient()

  const onDrop = React.useCallback(async acceptedFiles => {
    setUploading(true)

    const _files = await uploadFiles(acceptedFiles, client)

    setUploading(false)
    setDrag(false)

    props.uploadedFiles(_files)
  }, []) // eslint-disable-line

  const { getRootProps } = useDropzone({
    onDrop,
    onDragEnter: () => setDrag(true),
    onDragLeave: () => setDrag(false),
    onDragOver: () => setDrag(true),
    accept: 'image/jpg, image/png, image/jpeg, video/*, audio/*',
    multiple: true,
  })

  if (! props.active) {
    return props.children
  }

  return (
    <div {...getRootProps()} tabIndex={null}>
      <div
        className={classNames(
          'absolute left-0 top-0 w-full h-full z-50',
          'bg-disabled-100 bg-opacity-90 text-primary-600',
          'flex items-center justify-center',
          'pointer-events-none',
          'transition-all',
          {
            'opacity-0': !dragFiles,
          },
        )}
      >
        <div className='
          border-dashed border-2 border-primary-600
          flex flex-col space-y-5 items-center justify-center
          py-20 px-24
          pointer-events-none
        '>
          <Loader center active={uploading} />
          {
            ! uploading &&
            <>
              <FaUpload size='50' />
              <p>Drop files to upload</p>
            </>
          }
        </div>
      </div>
      {props.children}
    </div>
  )
}


DropUpload.propTypes ={
  uploadedFiles: propTypes.func.isRequired,
  active: propTypes.bool,
}

DropUpload.defaultProps = {
  active: true,
}
